import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CloudDownload, Print } from "@mui/icons-material";
import { Box, Button, Card, FormLabel, Grid, Icon, MenuItem, TextField } from "@mui/material";
import { Loader } from "app/components";
import { getAllProjectLocationListForBill } from "app/redux/actions/RABillActions";
import { getAllRaBillNoForReport, getRunningAccountBillForReport } from "app/redux/actions/ReportsAction";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { checkValidation, currencyFormat, formatDate, formatNumberWithCommasAndDecimals, getTwoDigitDecimal, renderKeyValuePairs } from "app/utils/utils";
import { SimpleCard } from "components";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import { formatRaBillNo } from '../RABill/deviationUtils';


const styles = {
  tableCell: {
    textAlign: "center"
  },
  subHeader: {
    textAlign: "center",
    fontWeight: 700
  }

}

export const RABillReport = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [projectDetails, setProjectDetails] = useState()
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const { projectLocationList } = useSelector((state) => state.raBill);
  const [raBillList, setRaBillList] = useState([])

  const [tableData, setTableData] = useState()
  const [grandTotal, setGrandTotal] = useState()

  const [state, setState] = useState({
    project_location_id: '',
    ra_bill_id: "",
    created_name: "",
    verified_name: "",
    recommended_name: "",
    approved_name: ""
  })

  useEffect(() => {
    dispatch(getAllProjectLocationListForBill(showLoader, hideLoader, showToast))
  }, []);

  const showLoader = () => {
    setLoading(true)
  }

  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  const hideLoader = () => {
    setLoading(false)
  }
  const handleChange = (event, source) => {
    setTableData()

    if (event.target.name === "project_location_id") {
      setRaBillList([])
      const filteredArray = projectLocationList.filter(project => {
        return project.project_location_id === event.target.value
      });
      state.project_name = filteredArray[0].project_name
      state.project_location_id = filteredArray[0].project_location_id
      state.project_id = filteredArray[0].project_id
      setLoading(true)
      setState({ ...state, [event.target.name]: event.target.value, ra_bill_id: "" });
      getAllRaBillNoForReport({ project_location_id: filteredArray[0].project_location_id }).then(res => {
        setLoading(false)
        if (res?.status < 300) {
          if (res?.data?.obj?.rabill_details?.length > 0) {
            setRaBillList(res?.data?.obj?.rabill_details)
          }

        } else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        }
      }).catch(error => {
        setLoading(false)
        const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      })
    } else {
      const filteredArray = raBillList.filter(raBill => raBill.runningaccountbill_id === event.target.value)
      setState({ ...state, [event.target.name]: parseInt(event.target.value), created_name: filteredArray[0].created_name, verified_name: filteredArray[0].verified_name, recommended_name: filteredArray[0].recommended_name, approved_name: filteredArray[0].approved_name });
    }
  }


  const handleFormSubmit = async () => {
    if (state?.project_location_id === "") {
      const key = enqueueSnackbar("Please select project location", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }
    else if (state?.ra_bill_id === "") {
      const key = enqueueSnackbar("Please select RA Bill No.", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }
    else {
      setLoading(true);
      setTableData();

      getRunningAccountBillForReport({
        project_location_id: state?.project_location_id,
        ra_bill_id: state?.ra_bill_id
      })
        .then((res) => {
          setLoading(false);
          console.log("response:", res);

          if (res?.status < 300) {
            if (res?.data?.success) {
              const responseData = res?.data?.obj;
              const itemObj = responseData?.item;
              const categories = itemObj?.categories;

              if (Array.isArray(categories) && categories.length > 0) {
                const table = categories.map((cat) => {
                  const constructionName = cat?.category_name ?? "";
                  const itemList = cat?.items ?? [];

                  const subTotal = itemList.reduce(
                    (sum, item) => sum + (parseFloat(item?.contract_amount) || 0),
                    0
                  );
                  const subTotalRevised = itemList.reduce(
                    (sum, item) => sum + (parseFloat(item?.revised_amount) || 0),
                    0
                  );

                  return {
                    construction_name: constructionName,
                    item_list: itemList,
                    sub_total_tender: getTwoDigitDecimal(subTotal),
                    sub_total_revised: getTwoDigitDecimal(subTotalRevised)
                  };
                });

                const grand_total_tender = table.reduce(
                  (sum, item) => sum + getTwoDigitDecimal(item?.sub_total_tender),
                  0
                );

                const grand_total_revised = table.reduce((sum, item) => {
                  const amount = getTwoDigitDecimal(item?.sub_total_revised);
                  const isRecovery = item?.construction_name?.includes("EXCESS PAYMENT RECOVERY");

                  return isRecovery
                    ? sum - getTwoDigitDecimal(amount)
                    : sum + getTwoDigitDecimal(amount);
                }, 0);

                setGrandTotal({
                  grand_tender_amount: getTwoDigitDecimal(grand_total_tender),
                  grand_revised_amount: getTwoDigitDecimal(grand_total_revised)
                });

                setTableData(table);
              }

              setProjectDetails({
                client: itemObj?.agency_name,
                company: itemObj?.company,
                contract_no: itemObj?.tender_id,
                project_id: itemObj?.project_id,
                project_name: itemObj?.project_name,
                dzongkhag_name: itemObj?.dzongkhagName,
                rabill_no: itemObj?.rabill_no,
                contract_amount: itemObj?.initial_contract_amount,
                rabill_date: itemObj?.rabill_date,
                bill_submission_date: itemObj?.bill_submission_date,
                project_location: itemObj?.project_location,
                header: responseData?.header_logo,
                footer: responseData?.footer_logo
              });
            } else {
              const key = enqueueSnackbar(res?.data?.message, { variant: "info" });
              SnackBarProperty.info(key, closeSnackbar);
            }
          } else {
            const key = enqueueSnackbar(res?.data?.message, { variant: "error" });
            SnackBarProperty.error(key, closeSnackbar);
          }
        })
        .catch((error) => {
          setLoading(false);
          const key = enqueueSnackbar(
            error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong,
            { variant: "error" }
          );
          SnackBarProperty.error(key, closeSnackbar);
        });

    }

  }

  const handleReportDownload = (isPrint) => {
    if (isPrint) {
      setIsPrinting(true)
      setIsDownloading(false)
    }
    else {
      setIsPrinting(false)
      setIsDownloading(true)
    }
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });
    const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
    const textY = headerHeight

    // Add the text content below the header image
    doc.setFont('helvetica', 'bold'); // Set font to bold
    doc.setFontSize(12); // Set font size
    doc.text("RUNNING ACCOUNT BILL", (doc.internal.pageSize.getWidth() / 2) - ((doc.getStringUnitWidth("RUNNING ACCOUNT BILL") * doc.internal.getFontSize() / doc.internal.scaleFactor) / 2), textY);

    // --- Execution ---
    const leftX = 15;
    const rightX = doc.internal.pageSize.getWidth() / 2;
    const lineSpacing = 5;
    const startOffsetY = 10; // Initial top padding relative to textY

    const rawFields = [
      { label: "Project ID:", value: projectDetails?.project_id },
      { label: "Project Name:", value: projectDetails?.project_name },
      { label: "Project Location:", value: projectDetails?.project_location },
      { label: "Client:", value: projectDetails?.client || "" },
      { label: "Contractor:", value: projectDetails?.company || "" },
      { label: "Contract Amount:", value: currencyFormat(projectDetails?.contract_amount) },
      { label: "RA Bill No.:", value: formatRaBillNo(projectDetails) },
      { label: "RA Bill Date:", value: formatDate(projectDetails?.rabill_date) },
      { label: "Bill Submission Date:", value: formatDate(projectDetails?.bill_submission_date) }
    ];

    const activeFields = rawFields.filter(item => checkValidation(item.value));

    const formattedDataList = activeFields.map((item, index) => {
      const isSecondColumn = index % 2 !== 0;
      const rowIndex = Math.floor(index / 2);

      return {
        ...item,
        posX: isSecondColumn ? rightX : leftX,
        posY: textY + startOffsetY + (rowIndex * lineSpacing)
      };
    });

    renderKeyValuePairs(doc, formattedDataList);

    // --- Dynamic Height Calculation ---
    const totalRows = Math.ceil(activeFields.length / 2); // Total rows in 2-column layout
    const dynamicContentHeight = startOffsetY + (totalRows * lineSpacing) + 5;


    const tableStartY = headerHeight + dynamicContentHeight;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(5);

    const body = []
    body.push([{ content: "", colSpan: 3 },
    { content: "Tender", styles: { fontStyle: "bold" } },
    { content: "Till Last RA", styles: { fontStyle: "bold" } },
    { content: "Current", styles: { fontStyle: "bold" } },
    { content: "Deviated", styles: { fontStyle: "bold" } },
    { content: "Cumulative", styles: { fontStyle: "bold" } },
      "",
    { content: "Tender", styles: { fontStyle: "bold" } },
    { content: "Revised", styles: { fontStyle: "bold" } },
    { content: "Tender", styles: { fontStyle: "bold" } },
    { content: "Revised", styles: { fontStyle: "bold" } }])
    tableData?.forEach((elem) => {
      body.push([
        { content: elem?.construction_name, colSpan: 12, styles: { fontStyle: "bold" } }
      ])
      elem?.item_list?.forEach((item) => {
        body.push([
          { content: getItemCode(elem?.construction_name, item) },
          { content: item?.boq_name },
          { content: item?.description },
          { content: `${currencyFormat(item?.contract_quantity)}` },
          { content: `${currencyFormat(item?.previous_quantity)}` },
          { content: `${currencyFormat(item?.new_quantity)}` },
          { content: `${currencyFormat(item?.deviation_quantity)}` },
          { content: `${currencyFormat(getTwoDigitDecimal(item?.prev_quantity) + getTwoDigitDecimal(item?.new_quantity) + getTwoDigitDecimal(item?.deviation_quantity))}` },
          { content: item?.unit_name },
          { content: currencyFormat(item?.contract_rate), styles: { halign: "right" } },
          { content: currencyFormat(item?.revised_rate), styles: { halign: "right" } },
          { content: currencyFormat(item?.contract_amount), styles: { halign: "right" } },
          { content: currencyFormat(item?.revised_amount), styles: { halign: "right" } }
        ])
      })
      body.push([
        { content: getSubTotalTitle(elem?.construction_name), colSpan: 11, styles: { fontStyle: "bold", halign: "right" } },
        { content: currencyFormat(elem?.sub_total_tender), colSpan: 1, styles: { fontStyle: "bold", halign: "right" } },
        { content: currencyFormat(elem?.sub_total_revised), colSpan: 1, styles: { fontStyle: "bold", halign: "right" } }
      ])
    })
    body.push([
      { content: "Grand Total", colSpan: 12, styles: { fontStyle: "bold", halign: "right" } },
      { content: currencyFormat(getTwoDigitDecimal(grandTotal?.grand_tender_amount) + getTwoDigitDecimal(grandTotal?.grand_revised_amount)), colSpan: 1, styles: { fontStyle: "bold", halign: "right" } },
    ])


    doc.autoTable({
      margin: {
        top: 30,      // push below header
        bottom: 30    // leave space above footer
      },
      startY: tableStartY,
      head: [[
        { content: "Item Code", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2 } },
        { content: "Name", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2 } },
        { content: "Description", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2 } },
        { content: "Quantity", colSpan: 5, styles: { valign: "middle", halign: "center", cellPadding: 2 } },
        { content: "Unit", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2 } },
        { content: "Rate (Nu)", colSpan: 2, styles: { valign: "middle", halign: "center", cellPadding: 2 } },
        { content: "Amount (Nu)", colSpan: 2, styles: { valign: "middle", halign: "center", cellPadding: 2 } }
      ]],
      body: body, // Use the transformed data here
      theme: "grid",
      styles: {
        fillColor: [255, 255, 255], // Remove background color from the table
        lineColor: [0, 0, 0], // Set border color for main table
        lineWidth: 0.1, // Set border width for main table
        textColor: [0, 0, 0], // Set text color to black
        cellPadding: 2, // Add padding to cells
        fontSize: 7
      },
      columnStyles: {
      },
    });
    doc.setFontSize(8);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text("Prepared by:", 15, doc.autoTable.previous.finalY + 10);
    const sub_text = doc.getStringUnitWidth("Prepared by:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
    doc.setFont('helvetica', 'normal');
    doc.text(`${state?.created_name ?? ""} `, 15 + 3 + sub_text, doc.autoTable.previous.finalY + 10);

    // Add "(Contractor)" below the name
    const nameX = 15 + 3 + sub_text;
    const nameY = doc.autoTable.previous.finalY + 10;
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(8);
    doc.text("(Contractor)", nameX, nameY + 5);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text(`Checked by:  `, doc.internal.pageSize.getWidth() - 100, doc.autoTable.previous.finalY + 10);
    const ver_text = doc.getStringUnitWidth("Checked by:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
    doc.setFont('helvetica', 'normal');
    doc.text(`${state?.verified_name ?? ""} `, doc.internal.pageSize.getWidth() - 100 + 3 + ver_text, doc.autoTable.previous.finalY + 10);

    const totalNumPages = doc.internal.getNumberOfPages();

    // Loop through each page to add the footer with page numbers
    for (let i = 1; i <= totalNumPages; i++) {

      const pdfWidth = doc.internal.pageSize.getWidth() - 30;

      // Header
      const headerHeight = 20;
      const headerX = 15;
      const headerY = 0; // at the very top
      if (checkValidation(projectDetails?.header)) {
        doc.addImage(
          `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
          headerX,
          headerY,
          pdfWidth,
          headerHeight
        );
      }

      //Footer
      const footerX = 15; // Starting X position for the footer
      const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
      const footerHeight = 20;
      doc.setPage(i);
      if (checkValidation(projectDetails?.footer)) {
        doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
      }
    }


    const scaleFactor = 1.0; // Adjust this value as needed
    const pdfBlob = doc.output('blob', { scale: scaleFactor });

    // Create a URL for the Blob
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open a new window with the PDF URL

    if (isPrint) {
      const newWindow = window.open(pdfUrl, '_blank');

      // After the new window is opened, you can close the URL object
      URL.revokeObjectURL(pdfUrl);
      if (newWindow) {
        newWindow.onload = () => {
          setIsPrinting(false)
          setIsDownloading(false)
          // Wait for the window to load and then trigger the print dialog
          newWindow.print();
        };
      }
    }

    setIsPrinting(false)
    setIsDownloading(false)

    isPrint === false && doc.save("Ra_Bill_Report.pdf");
  }

  const getSubTotalTitle = (construction_name) => {
    if (construction_name?.includes("EXCESS PAYMENT RECOVERY")) {
      return "Sub-Total (-)"
    } else {
      return "Sub-Total"
    }
  }

  const getItemCode = (construction_name, elem) => {
    if (construction_name?.includes("EXCESS PAYMENT RECOVERY")) {
      return `${elem?.item_code} (RA Bill No.: ${elem?.rabill_no}${elem?.is_amendment ? ", Amendment" : ""}) `
    } else {
      return elem?.item_code
    }
  }

  return (
    <>
      <div style={{ height: 'auto', width: "100%", padding: '30px', display: "flex", flexDirection: "column", gap: "20px" }}>

        <Grid container>

          <Grid item xs={12}>
            <Button
              size="small"
              sx={{ width: "100px" }}
              variant="contained"
              color="error"
              onClick={() => { window.history.back() }}
            >
              <Icon color="primary" fontSize="small">
                skip_previous
              </Icon>
              Back
            </Button>
          </Grid>
        </Grid>
        <SimpleCard>
          <ValidatorForm onSubmit={handleFormSubmit}>
            <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
              <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Running Account Bill</b></Grid>
            </Grid>
            <Grid container spacing={3} >

              <Grid item sm={4} xs={12}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="Project ID"
                  id="project_location_id"
                  variant="outlined"
                  name="project_location_id"
                  value={state?.project_location_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Project ID is required"]}
                >
                  {projectLocationList?.map((item) => (
                    <MenuItem value={item?.project_location_id} key={item?.project_id}>
                      {item?.project_id}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="RA Bill No."
                  id="rabill_is"
                  variant="outlined"
                  name="ra_bill_id"
                  value={state?.ra_bill_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Project ID is required"]}
                >
                  {raBillList?.map((item) => (
                    <MenuItem value={item?.runningaccountbill_id} key={item?.runningaccountbill_id}>
                      {item?.rabill_no}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item sm={4} xs={12}>


                <Button size="medium" color="success" variant="contained" type="submit" style={{ marginLeft: 4 }} >View</Button>

              </Grid>

            </Grid>

          </ValidatorForm>
        </SimpleCard>
        {
          tableData && tableData?.length > 0 &&
          <Grid container>
            <Grid xs={12} md={6}>
              {/* {checkValidation(projectDetails?.header) === false && <FormLabel sx={{ color: "#ff9800" }} color="warning">! Please upload header and footer for download/print</FormLabel>} */}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="span" display="flex" justifyContent="flex-end">
                <Button
                  size="small"
                  sx={{ width: "130px", marginLeft: 4 }}
                  variant="contained"
                  color="warning"
                  // disabled={projectDetails?.header ? false : true}
                  startIcon={<CloudDownload />}
                  onClick={() => { handleReportDownload(false) }}
                >
                  Download
                </Button>
                <Button
                  size="small"
                  sx={{ width: "100px", marginLeft: 2 }}
                  variant="contained"
                  color="primary"
                  // disabled={projectDetails?.header ? false : true}
                  startIcon={<Print />}
                  onClick={() => { handleReportDownload(true) }}
                >
                  Print
                </Button>
              </Box>
            </Grid>

          </Grid>}

        {/* table */}
        {
          tableData && tableData?.length > 0 && projectDetails &&
          <Card sx={{ padding: 3 }}>

            <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
              <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px", paddingLeft: "100px", paddingRight: "100px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
                  {checkValidation(projectDetails?.header) &&
                    <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "150px", width: "auto" }} alt="img" />
                  }
                </div>
              </div>

              <Grid container >
                <Grid item xs={12} sx={{ marginTop: 2, textAlign: "center" }}>
                  <FormLabel sx={{ fontSize: 20 }}><b>RUNNING ACCOUNT BILL</b></FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{projectDetails?.project_name}</FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Client: </b>{projectDetails?.client}</FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project ID: </b>{projectDetails?.project_id}</FormLabel>
                </Grid>

                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Contract Amount: </b>{formatNumberWithCommasAndDecimals(parseFloat(projectDetails?.contract_amount ?? 0).toFixed(2))}</FormLabel>
                </Grid>

                <Grid item xs={12} sx={{ marginTop: 2, marginBottom: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>RA Bill No.: </b>{formatRaBillNo(projectDetails)}</FormLabel>
                </Grid>
              </Grid>
            </div>

            <div id="tableData">
              <TableContainer component={Paper}>
                <Table>
                  <TableHead style={{ backgroundColor: '#87CEEB' }}>
                    <TableRow>
                      <TableCell rowSpan={2} style={{ width: '8%', textAlign: 'center' }}>Code</TableCell>
                      <TableCell rowSpan={2} style={{ width: '8%', textAlign: 'center' }}>Name</TableCell>
                      <TableCell rowSpan={2} style={{ width: '15%', whiteSpace: 'wrap', textAlign: "center" }} align="center">Description</TableCell>
                      <TableCell colSpan={5} align="center" style={{ width: '300px', whiteSpace: 'nowrap' }}>Quantity</TableCell>
                      <TableCell rowSpan={2} align="center">Unit</TableCell>
                      <TableCell colSpan={2} align="center">Rate(Nu)</TableCell>
                      <TableCell colSpan={2} align="center">Amount(Nu)</TableCell>
                    </TableRow>

                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell style={styles?.subHeader} colSpan={3}></TableCell>
                      <TableCell style={styles?.subHeader}>Tender</TableCell>
                      <TableCell style={styles?.subHeader}>Till Last RA</TableCell>
                      <TableCell style={styles?.subHeader}>Current</TableCell>
                      <TableCell style={styles?.subHeader}>Deviated</TableCell>
                      <TableCell style={styles?.subHeader}>Cumulative</TableCell>
                      <TableCell style={styles?.subHeader} colSpan={1}></TableCell>
                      <TableCell style={styles?.subHeader}>Tender</TableCell>
                      <TableCell style={styles?.subHeader}>Revised</TableCell>
                      <TableCell style={styles?.subHeader}>Tender</TableCell>
                      <TableCell style={styles?.subHeader}>Revised</TableCell>
                    </TableRow>
                    {tableData && tableData?.map((data) => {
                      return (
                        <>
                          <TableRow>
                            <TableCell colSpan={13}><b>{data?.construction_name}</b></TableCell>
                          </TableRow>
                          {
                            data?.item_list?.map((elem) => {
                              return (
                                <TableRow>
                                  <TableCell>{getItemCode(data?.construction_name, elem)}</TableCell>
                                  <TableCell>{elem?.boq_name}</TableCell>
                                  <TableCell style={{ width: "20%" }}><div className="description-cell">{elem?.description}</div></TableCell>
                                  <TableCell style={{ textAlign: "center" }}>{currencyFormat(elem?.contract_quantity)}</TableCell>
                                  <TableCell style={{ textAlign: "center" }}>{currencyFormat(elem?.previous_quantity)}</TableCell>
                                  <TableCell style={{ textAlign: "center" }}>{currencyFormat(elem?.new_quantity)}</TableCell>
                                  <TableCell style={{ textAlign: "center" }}>{currencyFormat(elem?.deviation_quantity)}</TableCell>
                                  <TableCell style={{ textAlign: "center" }}>{currencyFormat(getTwoDigitDecimal(elem?.prev_quantity) + getTwoDigitDecimal(elem?.new_quantity) + getTwoDigitDecimal(elem?.deviation_quantity))}</TableCell>
                                  <TableCell style={{ textAlign: "center" }} >{elem?.unit_name}</TableCell>
                                  <TableCell style={{ textAlign: "center" }}>{currencyFormat(elem?.contract_rate)}</TableCell>
                                  <TableCell>{currencyFormat(elem?.revised_rate)}</TableCell>
                                  <TableCell style={{ textAlign: "center" }}>{currencyFormat(elem?.contract_amount)}</TableCell>
                                  <TableCell style={{ textAlign: "center" }}>{currencyFormat(elem?.revised_amount)}</TableCell>
                                </TableRow>
                              )
                            })
                          }
                          <TableRow>
                            <TableCell colSpan={11} align="right"><b>{getSubTotalTitle(data?.construction_name)}</b></TableCell>
                            <TableCell align="right"><b>{currencyFormat(data?.sub_total_tender)}</b></TableCell>
                            <TableCell align="right"><b>{currencyFormat(data?.sub_total_revised)}</b></TableCell>
                          </TableRow>
                        </>
                      )
                    })}
                    <TableRow>
                      <TableCell colSpan={12} align="right"><b>Grand Total</b></TableCell>
                      <TableCell align="right"><b>{currencyFormat(getTwoDigitDecimal(grandTotal?.grand_tender_amount) + getTwoDigitDecimal(grandTotal?.grand_revised_amount))}</b></TableCell>
                    </TableRow>

                  </TableBody>


                </Table>

              </TableContainer>
            </div>
          </Card>}


      </div>
      {loading && (
        <Loader
          show={loading}
        />
      )}
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please wait."
        />
      )}

    </>
  )
}